import { BpType } from '../enums';

export const BpStatusStyle = {
  [BpType.OPTIMAL]: {
    badge: null,
    bg: 'bg-[#007b7d1f]',
    badgeBg: 'bg-[#017c7e]',
    badgeColor: 'text-[#ffffff]',
    color: '#017c7e',
  },
  [BpType.NORMAL]: {
    badge: 'N',
    bg: 'bg-[#7ac41e3d]',
    badgeBg: 'bg-[#7ac41e]',
    badgeColor: 'text-[#000000f0]',
    color: '#7ac41e',
  },
  [BpType.ELEVATED]: {
    badge: 'E',
    bg: 'bg-[#ffb03a33]',
    badgeBg: 'bg-[#ffb03a]',
    badgeColor: 'text-[#000000f0]',
    color: '#ffb03a',
  },
  [BpType.STAGE_1]: {
    badge: '1',
    bg: 'bg-[#ff7d0452]',
    badgeBg: 'bg-[#ff7d04]',
    badgeColor: 'text-[#ffffff]',
    color: '#ff7d04',
  },
  [BpType.STAGE_2]: {
    key: 'STAGE_2',
    badge: '2',
    bg: 'bg-[ed24093d]',
    badgeBg: 'bg-[#ed2409]',
    badgeColor: 'text-[#ffffff]',
    color: '#ed2409',
  },
  [BpType.STAGE_3]: {
    badge: '3',
    bg: 'bg-[#b6012152]',
    badgeBg: 'bg-[#b60121]',
    badgeColor: 'text-[#ffffff]',
    color: '#b60121',
  },
  [BpType.HYPERTENSIVE_CRISIS]: {
    badge: 'HC',
    bg: 'bg-[#b6012152]',
    badgeBg: 'bg-[#b60121]',
    badgeColor: 'text-[#ffffff]',
    color: '#b60121',
  },
  [BpType.PENDING]: {
    badge: null,
    bg: 'bg-[#eaeaea]',
    badgeBg: 'bg-[#d0d0ce]',
    badgeColor: 'text-[#000000f0]',
    color: '#d0d0ce',
  },
};
